import {
  HttpErrorResponse,
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { tap } from 'rxjs';
import { recordBackendTiming } from '../shared/utils/ssr-backend-timing.util';
import { REQUEST } from '@/tokens/injection-tokens';

const SLOW_REQUEST_MS = 1000;

export const backendTimingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPlatformServer(inject(PLATFORM_ID)) || req.url.includes('/assets/')) {
    return next(req);
  }

  // `optional: true` porque fuera de un request real (p. ej. prerender en
  // build) puede no haber un Express req en el injector.
  const expressReq = inject(REQUEST, { optional: true });
  const start = Date.now();

  const finish = (status: number | string): void => {
    const durationMs = Date.now() - start;
    const line = `[SSR→backend] ${req.method} ${req.urlWithParams} → ${status} (${durationMs}ms)`;

    if (durationMs > SLOW_REQUEST_MS) {
      console.warn(`🐢 ${line}`);
    } else {
      console.log(line);
    }

    if (expressReq) {
      recordBackendTiming(expressReq, {
        method: req.method,
        url: req.urlWithParams,
        status,
        durationMs,
      });
    }
  };

  return next(req).pipe(
    tap({
      next: (event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) finish(event.status);
      },
      error: (err: unknown) => {
        finish(err instanceof HttpErrorResponse ? err.status : 'ERR');
      },
    })
  );
};
